import { Expose } from "class-transformer";
import { IsString } from "class-validator";

export class ContractViewModel {
  @IsString()
  @Expose()
  name!: string;
  @IsString()
  @Expose()
  description!: string;
}
